interface MedOrRecStore {
  recreational?: boolean;
}

export const byMedical = (
  { recreational: aRec }: MedOrRecStore,
  { recreational: bRec }: MedOrRecStore
) => {
  if (aRec === bRec) {
    return 0;
  }
  return aRec ? 1 : -1;
};
